import { get, call } from 'vuex-pathify';
import { handleException, fetcher } from './store/apim-api';

const FetchMixin = {
  computed: {
    projectId: get('account2/projectId'),
  },
  beforeRouteEnter(to, from, next) {
    if (to.query && to.query.project_key_str) {
      const projectId = to.query.project_key_str;
      next(async (vm) => {
        // access to component instance via `vm`
        await vm.setProject({ id: projectId });
        const query = { ...vm.$route.query };
        if (query.project_key_str) {
          delete query.project_key_str;
          const newTo = { query };
          vm.$router.replace(newTo);
        }
      });
    } else {
      next();
    }
  },
  mounted() {
    this.clearAPIErrors();
  },
  methods: {
    async fetch(funcName, params) {
      // console.log('Fetch ', funcName, params);
      return this.$fetcher[funcName](params).catch(async (except) => {
        const error = await handleException(except);
        this.storeAPIError({ name: funcName, error });
        return false;
      });
    },
    ...Object.getOwnPropertyNames(Object.getPrototypeOf(fetcher)).reduce(
      (acc, funcName) => ({
        ...acc,
        [`fetch_${funcName}`](...params) {
          return this.fetch(funcName, ...params);
        },
      }),
      {},
    ),
    ...call('apimAPI', ['clearAPIErrors', 'storeAPIError']),
    setProject: call('account2/setProject'),
  },
  watch: {
    projectId(val) {
      //  console.log('FetchMixin projectId to', val, 'was', oldVal);
      if (val) {
        //  console.log('FetchMixin fetchData');
        this.clearAPIErrors();
        this.fetchData();
      }
    },
    '$auth.isAuthenticated': function _isAuth(isAuthenticated) {
      if (isAuthenticated) {
        this.fetchData();
      }
    },
  },
};
export default FetchMixin;
